import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { UnauthorizedError } from '../api/client';
import styles from './Login.module.css';
export function Login({ onLogin, notice }) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const submit = async () => {
        if (!username.trim() || !password) {
            setError('Benutzername und Passwort eingeben.');
            return;
        }
        setSubmitting(true);
        setError(null);
        try {
            await onLogin(username.trim(), password);
        }
        catch (e) {
            if (e instanceof UnauthorizedError)
                setError('Benutzername oder Passwort ist falsch.');
            else if (e instanceof TypeError)
                setError('Server nicht erreichbar – bitte später erneut versuchen.');
            else
                setError(e instanceof Error && e.message ? e.message : 'Anmeldung fehlgeschlagen.');
            setPassword('');
        }
        finally {
            setSubmitting(false);
        }
    };
    return (_jsxs("div", { className: styles.overlay, children: [_jsxs("div", { className: styles.headBlock, children: [_jsx("div", { className: styles.kicker, children: "Poolmanagement" }), _jsx("div", { className: styles.title, children: "Anmelden" }), _jsx("div", { className: styles.subline, children: "Werte und Pflege-Protokoll sind nach der Anmeldung sichtbar." })] }), _jsxs("div", { className: styles.card, children: [notice && !error && _jsx("div", { className: styles.notice, children: notice }), _jsx("label", { className: styles.label, children: "Benutzername" }), _jsx("input", { type: "text", value: username, onChange: e => {
                            setUsername(e.target.value);
                            setError(null);
                        }, autoComplete: "username", placeholder: "z. B. sommer", className: styles.input }), _jsx("label", { className: styles.labelSpaced, children: "Passwort" }), _jsx("input", { type: "password", value: password, onChange: e => {
                            setPassword(e.target.value);
                            setError(null);
                        }, onKeyDown: e => {
                            if (e.key === 'Enter')
                                void submit();
                        }, autoComplete: "current-password", placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022", className: styles.input }), error && _jsx("div", { className: styles.error, children: error }), _jsx("button", { type: "button", onClick: () => void submit(), disabled: submitting, className: styles.submit, children: "Anmelden" })] })] }));
}
